import { render, staticRenderFns } from "./QueryStatus.vue?vue&type=template&id=6c87ca14&scoped=true&"
import script from "./QueryStatus.vue?vue&type=script&lang=js&"
export * from "./QueryStatus.vue?vue&type=script&lang=js&"
import style0 from "./QueryStatus.vue?vue&type=style&index=0&id=6c87ca14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87ca14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c87ca14')) {
      api.createRecord('6c87ca14', component.options)
    } else {
      api.reload('6c87ca14', component.options)
    }
    module.hot.accept("./QueryStatus.vue?vue&type=template&id=6c87ca14&scoped=true&", function () {
      api.rerender('6c87ca14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenders/review/QueryStatus.vue"
export default component.exports